<!-- Need two separate mat-selects to avoid 'changed after checked' errors -->
<!-- from formControl and disabled input interaction -->
@if (validationControl) {
  <mat-form-field appearance="fill" class="time-picker__container">
    <mat-select #timeSelect
      data-testid="time-picker"
      [placeholder]="placeholder"
      [formControl]="validationControl"
      (selectionChange)="timeSelected.emit($event.value)">
      <mat-select-trigger class="time-picker__option">{{time}}</mat-select-trigger>
      @for (time of displayTimes; track time) {
        <mat-option class="time-picker__option" [disabled]="checkTimeDisabled(time)" [value]="time">{{time}}</mat-option>
      }
    </mat-select>
    <!-- ngIf is required here to avoid angular mat select validation defect -->
    @if (timeSelect.errorState) {
      <mat-error>{{placeholder}} is required</mat-error>
    }
  </mat-form-field>
}
@if (!validationControl) {
  <mat-form-field appearance="fill"  class="time-picker__container">
    @if (!validationControl) {
      <div>
        <mat-select
          [placeholder]="placeholder"
          [disabled]="disabled"
          data-testid="time-picker"
          (selectionChange)="timeSelected.emit($event.value)">
          <mat-select-trigger class="time-picker__option">{{time}}</mat-select-trigger>
          @for (time of displayTimes; track time) {
            <mat-option class="time-picker__option" [disabled]="checkTimeDisabled(time)" [value]="time">{{time}}</mat-option>
          }
        </mat-select>
      </div>
    }
  </mat-form-field>
}
